(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["turron-whatsapp"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('turron-whatsapp');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const panel = root.querySelector('#twa-panel');
  const toggle = root.querySelector('.twa-toggle');
  const close = root.querySelector('.twa-close');
  const input = root.querySelector('input');
  const form = root.querySelector('form');
  const send = form.querySelector('button');
  function setOpen(open, restoreFocus = true) {
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    if (open) {
      root.querySelector('time').textContent = new Date().toLocaleTimeString(document.documentElement.lang || 'es', {hour:'2-digit',minute:'2-digit'});
      close.focus({preventScroll:true});
    } else if (restoreFocus) toggle.focus({preventScroll:true});
  }
  toggle.addEventListener('click', event => {event.preventDefault(); setOpen(panel.hidden);});
  toggle.addEventListener('keydown', event => {if (event.key === ' ') {event.preventDefault();setOpen(panel.hidden);}});
  close.addEventListener('click', () => setOpen(false));
  document.addEventListener('pointerdown', event => {if (!panel.hidden && !root.contains(event.target)) setOpen(false, false);});
  document.addEventListener('keydown', event => {if (event.key === 'Escape' && !panel.hidden) {event.preventDefault();setOpen(false);}});
  input.addEventListener('input', () => {send.disabled = !input.value.trim();});
  form.addEventListener('submit', event => {
    event.preventDefault();
    const message = input.value.trim();
    if (!message) return;
    window.open('https://wa.me/' + root.dataset.phone + '?text=' + encodeURIComponent(message), '_blank', 'noopener,noreferrer');
  });
})();
  } catch(e) { console.error(e); }
})();

})();
